import { createContext, type PropsWithChildren, useContext, useMemo } from 'react';

import type { Translations } from '~/utils/translations/types';

type TranslationsContextType = {
  translations: Translations;
};

type TranslationsContextProps = {
  translations: Translations;
};

const TranslationsContext = createContext<TranslationsContextType>({ translations: {} as Translations });

export const TranslationsContextProvider = ({
  children,
  translations,
}: PropsWithChildren<TranslationsContextProps>) => {
  const value = useMemo(() => ({ translations }), [translations]);

  return <TranslationsContext.Provider value={value}>{children}</TranslationsContext.Provider>;
};

export const useTranslationsContext = () => useContext(TranslationsContext);
